// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Interfaces
import { HorizontalAlignEnum, VerticalAlignEnum } from '@utmb/types/modal';
import { DashboardModalProps } from '@utmb/types/dashboard-modal';
// Design System
import { Modal } from '@utmb/design-system/modal/Modal';
// Features
import { UserEditWrapper } from '@utmb/features/user-edit-wrapper/UserEditWrapper';
import MyModalFooter from '@utmb/features/my-modal-footer/MyModalFooter';
import { UserAccountChangePasswordForm } from '@utmb/features/my-utmb/user-account-settings-form/UserAccountChangePasswordForm';

export const ModalOrganizerChangePassword = (props: DashboardModalProps): ReactElement => {
    const { isOpen, close } = props;

    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={close} vAlign={VerticalAlignEnum.TOP} hAlign={HorizontalAlignEnum.RIGHT}>
            <UserEditWrapper title={t('myutmb:myUtmb.myInformation.accountSettings.title')}>
                <UserAccountChangePasswordForm onCancel={() => close(false)} />
            </UserEditWrapper>
            <MyModalFooter />
        </Modal>
    );
};
